import { Flex, NumberInput, Text } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";

import {
  MAX_FILL_PRODUCTS_COUNT,
  fillCountAtom,
} from "../store/atoms/fillCountAtom";

export const FillConfirm = () => {
  const [count, setCount] = useAtom(fillCountAtom);

  return (
    <Flex direction={"column"} gap={4}>
      <Text variant="body-1">
        Укажите необходимое кол-во товаров для заполнения
      </Text>
      <NumberInput
        value={count}
        onUpdate={(value) => setCount(value || 0)}
        placeholder="Укажите кол-во товаров"
        min={1}
        max={MAX_FILL_PRODUCTS_COUNT}
        hiddenControls
      />
    </Flex>
  );
};
